import { chunk } from 'lodash-es'
import UserRow from '../../Grid/UserRow'
import { getRowHeight, resolveDisplayContainer } from '../../Grid/helpers'

type DisplayModels = {
    displayComponentProps?: any
    rowComponentProps?: any
    displayBanner?: boolean
}

export const getRows = (props) => {
    const {
        forceGridRefresh,
        displayHeight,
        gridPadding,
        columnWidth,
        columnCount,
        platform,
        getStyle,
        display,
        scale,
        data,
    } = props

    if (!data) {
        return []
    }

    const DisplayComponent = resolveDisplayContainer(display)

    const displayModels = (list, config: DisplayModels = {}) => {
        const { displayComponentProps, rowComponentProps, displayBanner } =
            config

        const rowHeight = getRowHeight({
            displayHeight,
            displayBanner,
            gridPadding,
            platform,
            display,
            scale,
        })

        return chunk(list, columnCount).map((data) => {
            const itemKey = data.reduce(
                (memo: string, { id }) => (memo ? memo + '-' + id : String(id)),
                '',
            )

            return {
                ...config,
                rowComponentProps: {
                    displayComponentProps: {
                        forceGridRefresh,
                        displayHeight,
                        gridPadding,
                        columnWidth,
                        ...displayComponentProps,
                    },
                    DisplayComponent,
                    displayHeight,
                    gridPadding,
                    columnWidth,
                    rowHeight,
                    getStyle,
                    data,
                    ...rowComponentProps,
                },
                RowComponent: UserRow,
                rowHeight,
                itemKey,
            }
        })
    }

    const isAvatarOrTextView = display === 'default' || display === 'text'
    const { models, ...other } = data

    const rows = [
        ...displayModels(models, {
            displayComponentProps: {
                ...other,
                enableLargePreview: false,
                displayStatusBadge: isAvatarOrTextView,
                displayBookmarkHighlight: true,
                displayFriendHighlight: true,
                displayBookmarkBadge: true,
                displayFriendBadge: true,
                passiveMode: false,
                enablePin: false,
                getStyle,
            },
        }),
    ]

    return rows
}
